/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Scenarist_Bg_HintInputs */



/**
* | output |
* | --- |
* | "Scenarist Script uses a white background and a 4-color DVD palette." |
*
* @param {Image_Export_Scenarist_Bg_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_scenarist_bg_hint = /** @type {((inputs?: Image_Export_Scenarist_Bg_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Scenarist_Bg_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Scenarist Script utilise un fond blanc et une palette DVD 4 couleurs.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Scenarist Script verwendet einen weissen Hintergrund und eine 4-Farben-DVD-Palette.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scenarist Script usa uno sfondo bianco e una tavolozza DVD a 4 colori.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Scenarist Script использует белый фон и 4-цветную DVD-палитру.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Scenarist Script usa un fondo blanco y una paleta DVD de 4 colores.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Scenarist Script 使用白色背景和四色 DVD 调色板。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Scenarist Script は白背景と 4 色の DVD パレットを使用します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Scenarist Script सफेद पृष्ठभूमि और 4-रंग DVD पैलेट का उपयोग करता है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O Scenarist Script usa um fundo branco e uma paleta DVD de 4 cores.")
	return /** @type {LocalizedString} */ ("Scenarist Script uses a white background and a 4-color DVD palette.")
});